import { IParamsToSend } from '@base/@types/providers/Alert/AlertPurchaseProvider'

export const alertProcessRequest: IParamsToSend = {
  fornecedoresIds: [],
  centerTypes: [],
  lojasIds: [],
  produtosIds: [],
  pedidosIds: [],
  statusPedidos: [],
  tiposProcessos: [],
  usuariosIds: [],
  periodo: {
    inicio: new Date().toISOString(),
    final: new Date().toISOString(),
    agrupar: false
  }
}
